const addClientIpHeader = ({ clientIp }: { clientIp?: string | null }) =>
  clientIp
    ? {
        'x-client-ip': clientIp,
        'X-Forwarded-For': clientIp,
      }
    : {};

export default addClientIpHeader;
